import styled from "styled-components";

/**
 * Cabeçalho da lista: título à esquerda e ação principal à direita.
 * No mobile o botão ocupa a largura toda, abaixo do título.
 */
export const ListHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};
  margin-bottom: ${({ theme }) => theme.spacing(5)};

  & > h2 {
    margin-bottom: 0;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;

/** Botão "Novo alerta", no mesmo amarelo do botão de enviar da barra. */
export const NewAlertButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing(1.5)};
  padding: ${({ theme }) => theme.spacing(2.5)} ${({ theme }) => theme.spacing(5)};
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.large};
  background-color: ${({ theme }) => theme.colors.brightYellow};
  color: ${({ theme }) => theme.colors.ink};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.md};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  white-space: nowrap;
  cursor: pointer;
  box-shadow: ${({ theme }) => theme.shadows.light.small};
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: #ffd700;
    box-shadow: ${({ theme }) => theme.shadows.light.medium};
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.deepDarkBlue};
    outline-offset: 3px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 100%;
  }
`;
